import React from 'react';

import './App.scss';
import { Route, Routes } from 'react-router';

import { PageLayout } from './components/layout/main/PageLayout';
import { MaintenanceModeProvider } from "./contexts/maintenance-mode";
import { AnalyticsProvider } from './hooks/dataTracking/useAnalytics';
import usePageTracking from './hooks/usePageTracking';
import { ProposalPage } from './pages/Community/Voting/ProposalPage';
import { VotingPage } from './pages/Community/Voting/VotingPage';
import { NoMatchPage } from './pages/Errors/NoMatchPage';
import { FaqPage } from './pages/FaqPage';
import { MyProposalPage } from './pages/Proposals/MyProposalPage';
import { MyProposalsPage } from './pages/Proposals/MyProposalsPage';

function App() {
  usePageTracking();

  return (
      <div className="app-wrapper">
        <AnalyticsProvider>
          <PageLayout>
            <MaintenanceModeProvider>
              <Routes>
                <Route index element={<VotingPage />} />
                <Route path="/vote" element={<VotingPage />} />
                <Route path="/my-proposals" element={<MyProposalsPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/my-proposals/:id" element={<MyProposalPage />} />
                <Route path="/proposals/:id" element={<ProposalPage />} />
                <Route path="*" element={<NoMatchPage />} />
              </Routes>
            </MaintenanceModeProvider>
          </PageLayout>
        </AnalyticsProvider>
      </div>
  );
}

export default App;
